import { PaycodeFilter } from '../models';


export function getPaycodeFilter(params: any): PaycodeFilter {
  return {
    q: params.q,
  };
};

export function paycodeFilterParams(filter: PaycodeFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}
